import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import NPMVideo from '@rotaryintl/harris-video';

const Video = ({ sitecoreContext, params: { ComponentId } = {}, fields: { Src, Poster, FileName, Type, Format, children } = {} }) => {
  const webDamURL = typeof Src.value === 'object' ? Src?.value.src : Src.value;
  const webDamPoster = typeof Poster.value === 'object' ? Poster?.value.url : Poster?.value;
  return (
    <NPMVideo
      name={FileName?.value}
      video={{
        src: webDamURL,
        poster: webDamPoster,
      }}
      tracks={children?.map(({ fields: { Src, SrcLang, Kind, Label } }) => ({
        src: Src?.value,
        srcLang: SrcLang?.value,
        label: Label?.value,
        kind: Kind?.value,
      }))}
      sources={[
        {
          src: webDamURL,
          type: Type?.fields?.Value?.value || '',
        },
      ]}
      type={Type?.fields?.Value?.value || ''}
      format={Format?.fields?.Value?.value || ''}
    />
  );
};

export default withSitecoreContext()(Video);
